// extracted by mini-css-extract-plugin
export default {"cerrar":"CerrarCaja_cerrar__9IucR","content":"CerrarCaja_content__jj+GU","info":"CerrarCaja_info__nXkVU"};